import {Component, OnInit} from '@angular/core';
import {CdkDragDrop, DragDropModule, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {FormControl, FormRecord, FormsModule, ReactiveFormsModule, UntypedFormBuilder} from '@angular/forms';
import {NgbModal, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {CareService} from 'src/app/admin/admin-services/care.service';
import {UserService} from 'src/app/services/user-services/user.service';
import {User} from '../../models/user';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatOptionModule} from '@angular/material/core';
import {DatePipe, NgFor, NgIf} from '@angular/common';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, NgFor, MatOptionModule, MatIconModule, DragDropModule, MatChipsModule, NgIf, NgbTooltipModule, DatePipe]
})
export class AdminDashboardComponent implements OnInit {
  public priority = new FormControl<string|string[]|null>(null);
  public PriorityList: string[] = ['Bas', 'Normal', 'Important', 'Urgent'];

  public language = new FormControl<string|string[]|null>(null);
  public LanguageList: string[] = ['Français', 'Anglais', 'Espagnol'];

  public services = new FormControl<string|string[]|null>(null);
  public ServicesList: string[] = ['Visa', 'Logement', 'MRH', 'CAF', 'Banque'];
  public currentUser = {id:'',firstname : '',email:''};

  public STEP1:any[] = [];
  public STEP2:any[] = [];
  public STEP3:any[] = [];
  public administrators:User[] = [];
  public allTasks:any[] =[];
  public currentUserAdminId:string|null;
  public taskForm: FormRecord<FormControl<string|null>> ;

  constructor(
    private modalService: NgbModal,
    private careService: CareService,
    private formBuilder: UntypedFormBuilder,
    private userService: UserService
  )
  {
    this.taskForm = this.formBuilder.record({
      title :"",
      service :"",
      language:"",
      priority:"",
      content:"",
      user_id:""
    });
  }


  ngOnInit(): void {
    // this.userService.getDatas().subscribe((data: any) => {
    //   this.currentUser = data;
    // });
    // this.getTasks();
    // this.careService.getAdministrators().subscribe((data: any) => {
    //   this.administrators = data;
    //   this.administrators.forEach(element => {
    //     if(element.email == this.currentUser.email){
    //       this.currentUserAdminId = element.id.toString();
    //     }
    //   });
    // });

  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      let t = event.item.data;
      t.state = event.container.id;
      this.careService.updateTask(t).subscribe(
        (response) => {});
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }


  open(content) {
    this.modalService.open(content);
  }

  onSubmit(){
    let task = this.taskForm.getRawValue();
    task.owner_id = this.currentUserAdminId;
    task.state = 'TO_DO';
    this.careService.createTask(task).subscribe(
      (response) => {
        this.getTasks();
        this.modalService.dismissAll();
      });
  }

  private getTasks(): void {
    this.STEP1 = [];
    this.STEP2 = [];
    this.STEP3 = [];
    this.careService.getTasks().subscribe(
      (data) => {
        this.getStepedItem(data, 'init');
      }
    )
  }

  public doFilter(): void {
    this.STEP1 = [];
    this.STEP2 = [];
    this.STEP3 = [];

    let filtered = [];
    filtered = this.filterByCategory(this.allTasks, this.priority)
    filtered = this.filterByCategory(filtered, this.language);
    filtered = this.filterByCategory(filtered, this.services);
    this.getStepedItem(filtered, 'filter');
  }

  private filterByCategory(array, item): any[] {
    let value = null;
    const filteredArray = [];
    if (!item || !item.value) {
      return array;
    }
    switch (item) {
      case this.priority : {
        value = 'priority';
        break;
      }
      case this.language: {
        value = 'language';
        break;
      }
      default : {
        value = 'service';
        break;
      }
    }

    array.forEach(element => {
      if(item.value.length == 0 || item.value.indexOf(element[value]) > -1){
        filteredArray.push(element);
      }
    });
    return filteredArray;
  }

  private getStepedItem(array, state): void {
    array.forEach(element => {
      if(element.state == 'TO_DO'){
        this.STEP1.push(element);
      }
      if(element.state == 'IN_PROGRESS'){
        this.STEP2.push(element);
      }
      if(element.state == 'DONE'){
        this.STEP3.push(element);
      }
    })
    if (state && state == 'init') {
      this.allTasks = array;
    }
  }



}
